export default () => {
  const isSecurityTypesChecked = $(
    "#incident_report_incident_is_assault_violence_fight_or_other_security_incident"
  );
  const isSecurityTypesContainer = $(".incident-is-security-incident-types-container");

  if (!isSecurityTypesChecked.is(":checked")) {
    isSecurityTypesContainer.hide();
  }

  isSecurityTypesChecked.on("change", () => {
    if (isSecurityTypesChecked.is(":checked")) {
      isSecurityTypesContainer.show();
    } else {
      // uncheck all of the inputs inside container
      isSecurityTypesContainer.find('input[type="checkbox"]').prop("checked", false);
      isSecurityTypesContainer.find('input[type="checkbox"]').each(function () {
        $(this).trigger("change");
      });

      isSecurityTypesContainer.hide();
    }
  });
};
